import React from "react";
// @ts-ignore
import cardUtils from "@fdr-mar/utils/cardSlotUtils";
import { CardSlot } from "@fdr-mar/promos-types/Component";
import { Header } from "@tvg/design-system/web";

import Slot from "../Slot";

import {
  TopPromotionsContainer,
  PromoSlotsWrapper,
  FeaturedSlotsContainer,
  HeaderContainer
} from "./styled-components";

type Content = {
  header: string;
  slots: CardSlot[];
};

interface Props {
  content: Content;
}

const FeaturedSlots = ({ content }: Props) => {
  const renderSlots = (slots: CardSlot[]) => {
    const tabletLastRowCardsIndex = cardUtils.detectCardsLastRow(
      slots.length,
      2
    );
    const desktopLastRowCardsIndex = cardUtils.detectCardsLastRow(
      slots.length,
      3
    );

    /* eslint-disable no-underscore-dangle */
    return slots.map((slot, index) => (
      <Slot
        key={slot._uid}
        isTopPromo
        content={slot}
        position={index + 1}
        className={`
              ${index > tabletLastRowCardsIndex ? "tabletLastRow" : ""}
              ${index > desktopLastRowCardsIndex ? "desktopLastRow" : ""}
            `}
      />
    ));
  };

  return (
    <TopPromotionsContainer>
      <HeaderContainer>
        <Header
          tag="h1"
          qaLabel="promo-title"
          fontFamily="bold"
          color="--fd-colors-content-strong"
          fontSize="var(--fd-font-sizes-heading-medium)"
          lineHeight="24px"
        >
          {content.header}
        </Header>
      </HeaderContainer>
      <PromoSlotsWrapper>
        <FeaturedSlotsContainer data-qa-label="featuredSlotsContainer">
          {renderSlots(content.slots)}
        </FeaturedSlotsContainer>
      </PromoSlotsWrapper>
    </TopPromotionsContainer>
  );
};

export default FeaturedSlots;
